import { render, staticRenderFns } from "./receivablesInfo.vue?vue&type=template&id=2a8137b8"
import script from "./receivablesInfo.vue?vue&type=script&lang=js"
export * from "./receivablesInfo.vue?vue&type=script&lang=js"
import style0 from "./receivablesInfo.vue?vue&type=style&index=0&id=2a8137b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports